import {
  fontSizeMap,
  variantMap,
  marginBlockMap,
} from '@/constants/typography';

export type Variant = keyof typeof variantMap;
type TypographyProps = {
  children: React.ReactNode;
  variant?: Variant;
  fontWeight?: string;
  color?: string;
};

const Typography = ({
  children,
  color,
  fontWeight = 'normal',
  variant = 'body1',
}: TypographyProps) => {
  const VariantTag = variantMap[variant] as React.ElementType;

  return (
    <VariantTag
      style={{
        fontSize: fontSizeMap[variant],
        fontWeight,
        color,
        margin: `${marginBlockMap[variant]} 0`,
      }}
    >
      {children}
    </VariantTag>
  );
};

export default Typography;
